import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { CIDRFirewallRuleForm } from '#screens/routes/form/firewall-rule/CIDRFirewallRuleForm.tsx';
import type { CIDRFirewallRuleFormData } from '../cidr-firewall-rule-form-schema.ts';

type Props = {
  onSave: (firewallRule: CIDRFirewallRuleFormData) => void;
  onClose: () => void;
  firewallRule: CIDRFirewallRuleFormData;
};

/**
 *  Shows a form for editing an existing firewall rule on a route
 */
export function EditCIDRFirewallRuleModal({ onSave, onClose, firewallRule }: Props) {
  const modalRef = useRef(null);

  return (
    <Modal ref={modalRef} isOpen={true} onClose={onClose}>
      <ModalHeader>Edit route firewall rule</ModalHeader>
      <ModalBody>
        <CIDRFirewallRuleForm rule={firewallRule} onSave={onSave} />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button type="submit" form="cidr-firewall-rule-form">
              Save
            </Button>
          }
          secondaryButton={
            <Button variant="link" onClick={() => onClose()}>
              Cancel
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
